export type ConsentRegion = "gated" | "ungated"

// First-party cookie the edge function stamps and the client consent layer
// reads. Defined here — the browser-free classifier module — so the Netlify
// edge function can import it without pulling in any browser-coupled code.
export const REGION_COOKIE = "pc_region"

// The consent-gated set is a regulatory classification, not raw geography, so
// it's kept as a reviewed, version-controlled constant rather than derived at
// runtime. Grouped by the regime that gates each so a legal reviewer can audit
// the set directly. Membership is transcribed from the EU's official
// member-states list:
// https://european-union.europa.eu/principles-countries-history/eu-countries_en
const EU_27 = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
  "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
  "SI", "ES", "SE",
]
const EEA_EFTA = ["NO", "IS", "LI"] // EEA members outside the EU (EFTA minus CH)
const UK = ["GB"] // UK GDPR
const CH = ["CH"] // Switzerland — GDPR-adjacent FADP; EFTA, not EEA
// California (US-CA) is handled by subdivision below since its country code
// (US) is shared with un-gated states.

const GATED_COUNTRIES = new Set([...EU_27, ...EEA_EFTA, ...UK, ...CH])

export function classifyGeo(
  country?: string,
  subdivision?: string
): ConsentRegion {
  if (!country) return "gated"
  if (GATED_COUNTRIES.has(country)) return "gated"
  if (country === "US" && subdivision === "CA") return "gated"
  return "ungated"
}
